import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Checkbox from 'antd/lib/checkbox';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';

import { PunctuationAlert, TermsLabel } from '../../common/partials';
import rules from '../../../../common/rules/rules';
import accountRules from '../../../../common/rules/accountRules';
import {
  currencyFormatter,
  percentageFormatter,
  monthsFormatter,
} from '../../../../common/utils/helpers';
import { PasswordInput } from '../../../../common/components';

const { Item: FormItem } = Form;

@translate()
@Form.create()
export default class SignUpForm extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    amount: PropTypes.number.isRequired,
    months: PropTypes.number.isRequired,
    interest: PropTypes.number.isRequired,
    profit: PropTypes.number.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    repeatPasswordDirty: false,
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form, onSubmit } = this.props;

    form.validateFields((err, formData) => {
      if (!err) {
        onSubmit(formData);
      }
    });
  };

  handleUpperCaseFirst = e => {
    e.target.value = e.target.value.toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  handleNameBlur = name => e => {
    this.props.form.setFieldsValue({[name]: e.target.value.replace(/\s+/g,' ').trim()})
  }

  handleRepeatPasswordBlur = e => {
    const { repeatPasswordDirty } = this.state;

    this.setState({ repeatPasswordDirty: repeatPasswordDirty || !!e.target.value });
  };

  render() {
    const { t, amount, months, interest, profit, form, isLoading } = this.props;
    const { getFieldDecorator } = form;

    const { repeatPasswordDirty } = this.state;

    return (
      <Grid className="onboarding-wrapper">
        <Row between="xs">
          <Col xs={12} md={8}>
            <section className="onboarding-form">
              <h2 className="section-title">{t('Registračné údaje')}</h2>
              <PunctuationAlert />
              <Spin spinning={isLoading}>
                <Form layout="vertical" onSubmit={this.handleSubmit}>
                  <Row>
                    <Col xs={12} sm={6}>
                      <FormItem label={t('Krstné meno')}>
                        {getFieldDecorator('nameFirst', { rules: rules.required })(
                          <Input size="default" placeholder={t('Krstné meno')} autoFocus onChange={this.handleUpperCaseFirst} onBlur={this.handleNameBlur('nameFirst')}/>
                        )}
                      </FormItem>
                    </Col>
                    <Col xs={12} sm={6}>
                      <FormItem label={t('Priezvisko')}>
                        {getFieldDecorator('nameLast', { rules: rules.required })(
                          <Input size="default" placeholder={t('Priezvisko')} onChange={this.handleUpperCaseFirst} onBlur={this.handleNameBlur('nameLast')}/>
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6}>
                      <FormItem label={t('Marketingový kód')}>
                        {getFieldDecorator('marketingCode', { 
                          rules: [ 
                            rules.specificLength(5),
                            rules.numbersOrCharactersOnly
                          ] })(
                          <Input size="default" placeholder={t('Marketingový kód')}/>
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs>
                      <FormItem label={t('E-mail')}>
                        {getFieldDecorator('email', {
                          rules: accountRules.email,
                          validateTrigger: 'onBlur',
                        })(<Input size="default" placeholder={t('E-mail')} type="email" />)}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6}>
                      <FormItem label={t('Heslo')}>
                        {getFieldDecorator('password', {
                          rules: [
                            ...accountRules.passwordWithLimit,
                            {
                              validator: accountRules.checkRepeatPassword(
                                form,
                                repeatPasswordDirty
                              ),
                            },
                          ],
                        })(<PasswordInput placeholder={t('Heslo')} />)}
                      </FormItem>
                    </Col>
                    <Col xs={12} sm={6}>
                      <FormItem label={t('Overenie hesla')}>
                        {getFieldDecorator('repeatPassword', {
                          rules: [
                            ...accountRules.passwordWithLimit,
                            {
                              validator: accountRules.checkPassword(form),
                            },
                          ],
                          validateTrigger: 'onBlur',
                        })(
                          <Input
                            size="default"
                            type="password"
                            placeholder={t('Overenie hesla')}
                            onBlur={this.handleRepeatPasswordBlur}
                          />
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs>
                      <FormItem>
                        {getFieldDecorator('terms', {
                          rules: rules.radioAgreement,
                          initialValue: true,
                        })(
                          <div className="terms-wrapper">
                            <Checkbox defaultChecked={true} />
                            <TermsLabel />
                          </div>
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row center="xs" className="form-actions-row">
                    <Col xs={12} sm={6}>
                      <Button type="primary" size="large" htmlType="submit" className="btn-block">
                        {t('Vytvoriť profil')}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Spin>
            </section>
          </Col>
          <Col xs={12} md={4}>
            <section className="step-sidebar">
              <h2 className="section-title">{t('Údaje o investícii')}</h2>
              <div className="side-info">
                <div className="side-info-row">
                  <span>{t('Investícia')}</span>
                  <span>{currencyFormatter(amount)}</span>
                </div>
                <div className="side-info-row">
                  <span>{t('Predpokladaný úrok')}</span>
                  <span>{percentageFormatter(interest)} p.a.</span>
                </div>
                <div className="side-info-row">
                  <span>{t('Vráti sa Vám')}</span>
                  <span>{currencyFormatter(profit)}</span>
                </div>
                <div className="side-info-row">
                  <span>{t('Splatnosť')}</span>
                  <span>{monthsFormatter(months, true)}</span>
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/creditor/SignUpForm.js